// extracted by mini-css-extract-plugin
export default {"ActionMenu_Overlay":"sort-by-menu-module__ActionMenu_Overlay--x33vY","Box":"sort-by-menu-module__Box--VozRG","Box_1":"sort-by-menu-module__Box_1--yVmA7"};